/**
 * Created By Srijan Shakya
 * Created at 02/03/2020
 * https://marvelapp.com/4g4b5dg/screen/54237321
 */

import React from 'react';
import { Document, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import concat from 'ramda/src/concat';
import isEmpty from 'ramda/src/isEmpty';
import filter from 'ramda/src/filter';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import uniqBy from 'ramda/src/uniqBy';
import PdfHeader from '@components/PdfHeader';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '10px',
        paddingTop: '3px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
    },
    mainHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '3px',
        paddingTop: '10px',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: '8px 10px 0px 10px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
        minHeight: '40px',
        maxHeight: '75px',
    },
    pageNumbers: {
        position: 'absolute',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        margin: '10px',
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    listHeaderTitle: { fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' },
    listItemFont: { fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' },
});

const ListHabit = (data, title, userId) => {
    let pageIndex = 1;
    return (
        <View break>
            <View style={styles.mainHeader} fixed>
                <View style={{ flex: 4 }}>
                    <Text style={styles.title}>{title} Habits</Text>
                </View>
            </View>
            <View style={styles.listHeader} fixed wrap>
                <View style={{ flex: 11 }}>
                    <Text style={styles.listHeaderTitle}>Habits</Text>
                </View>
                <View style={{ flex: 2 }}>
                    <Text style={styles.listHeaderTitle}>Assigned</Text>
                </View>
                <View style={{ flex: 2, textAlign: 'right' }}>
                    <Text style={styles.listHeaderTitle}>Completed</Text>
                </View>
            </View>
            {isEmpty(data) ? (
                <View style={styles.listItem}>
                    <View style={{ flex: 11 }}>
                        <Text style={styles.listItemFont}>No Quotas Assigned</Text>
                    </View>
                    <View style={{ flex: 2 }}>
                        <Text style={styles.listItemFont}>Na</Text>
                    </View>
                    <View style={{ flex: 2, textAlign: 'right' }}>
                        <Text style={styles.listItemFont}>Na</Text>
                    </View>
                </View>
            ) : (
                data.map((habit) => {
                    let pageBreak = false;
                    if (pageIndex === 12) {
                        pageBreak = true;
                        pageIndex = 1;
                    }
                    pageIndex++;
                    return (
                        <View style={styles.listItem} key={habit.id} break={pageBreak}>
                            <View style={{ flex: 11 }}>
                                <Text style={styles.listItemFont}>{habit.name || habit.data.name}</Text>
                                <Text style={styles.listHeaderTitle}>{title}</Text>
                            </View>
                            <View style={{ flex: 2 }}>
                                <Text style={styles.listItemFont}>{isNil(habit.program_id) ? (habit.assignedBy === userId ? 'Self' : 'Manager') : `Program`}</Text>
                            </View>
                            <View style={{ flex: 2, textAlign: 'right' }}>
                                <Text style={styles.listItemFont}>{habit.completed ? habit.completed : 0}%</Text>
                            </View>
                        </View>
                    );
                })
            )}
        </View>
    );
};

const ListQuota = (data, title) => {
    let pageIndex = 1;
    return (
        <View break>
            <View style={styles.mainHeader} fixed>
                <View style={{ flex: 4 }}>
                    <Text style={styles.title}>{title} Quotas</Text>
                </View>
            </View>
            <View style={styles.listHeader} fixed>
                <View style={[title === 'Program' ? { flex: 8 } : { flex: 3 }]}>
                    <Text style={styles.listHeaderTitle}>Goals</Text>
                </View>
                <View style={{ flex: 2 }}>
                    <Text style={styles.listHeaderTitle}>{title === 'Scorecard' ? 'Scale' : 'Calculation'}</Text>
                </View>
                <View style={{ flex: 1, textAlign: 'right' }}>
                    <Text style={styles.listHeaderTitle}>Actual</Text>
                </View>
                <View style={{ flex: 1, textAlign: 'right' }}>
                    <Text style={styles.listHeaderTitle}>{title === 'Scorecard' ? 'Score' : 'Status'}</Text>
                </View>
            </View>
            {isEmpty(data) ? (
                <View style={styles.listItem}>
                    <View style={[title === 'Program' ? { flex: 8 } : { flex: 3 }]}>
                        <Text style={styles.listItemFont}>No Quotas Assigned</Text>
                    </View>
                    <View style={{ flex: 2 }}>
                        <Text style={styles.listItemFont}>Na</Text>
                    </View>
                    <View style={{ flex: 1, textAlign: 'right' }}>
                        <Text style={styles.listItemFont}>Na</Text>
                    </View>
                    <View style={{ flex: 1, textAlign: 'right' }}>
                        <Text style={styles.listItemFont}>Na</Text>
                    </View>
                </View>
            ) : (
                data?.map((quota, index) => {
                    let pageBreak = false;
                    if (index === 12) {
                        pageBreak = true;
                        pageIndex = 1;
                    }
                    pageIndex++;
                    return (
                        <View style={styles.listItem} key={`crd${index}`} break={pageBreak}>
                            {title === 'Scorecard' ? (
                                <>
                                    <View style={{ flex: 3 }}>
                                        <Text style={styles.listItemFont}>{quota.data.name || quota.name}</Text>
                                    </View>
                                    <View style={{ flex: 2, marginBottom: 5 }}>
                                        <Text style={styles.listItemFont}>{quota.data.star_values[0]} = 5.0</Text>
                                        <Text style={styles.listItemFont}>{quota.data.star_values[2]} = 4.0</Text>
                                        <Text style={styles.listItemFont}>{quota.data.star_values[3]} = 2.0</Text>
                                    </View>
                                </>
                            ) : (
                                <>
                                    <View style={{ flex: 8 }}>
                                        <Text style={styles.listItemFont}>{quota.data.name || quota.name}</Text>
                                        <Text style={styles.listHeaderTitle}>{quota.data.description}</Text>
                                    </View>
                                    <View style={{ flex: 2 }}>
                                        <Text style={styles.listItemFont}> {quota.data.quota_calculation}</Text>
                                    </View>
                                </>
                            )}
                            <View style={{ flex: 1, textAlign: 'right' }}>
                                <Text style={styles.listItemFont}>{quota.actuals[0] ? quota.actuals[0].actual : 0}</Text>
                            </View>
                            <View style={{ flex: 1, textAlign: 'right' }}>
                                {title === 'Scorecard' ? <Text style={styles.listItemFont}>3.0</Text> : <Text style={styles.listItemFont}>{quota.status}</Text>}
                            </View>
                        </View>
                    );
                })
            )}
        </View>
    );
};

export const AssignmentsToDoPdf = (props) => {
    const { date, scorecards, programs, quotas, habitSchedules, userId, dailyHabits, weeklyHabits, monthlyHabits } = props;
    const program = filter((program) => program.status !== 3, programs);
    const dateStart = moment(date.start).format('MMM DD');
    const dateEnd = moment(date.end).format('MMM DD');
    const pageTitle = 'Reports - Assignments - ToDo';
    let scorecardQuotas = [];
    let scorecardTitle = [];
    let programTitle = [];
    let programCourseItems = 0;
    let habitSchedulesTitle = [];
    let habitsItem = 0;

    scorecards &&
        scorecards.map((card) => {
            const { title, quotas } = card;
            if (!isNil(quotas)) scorecardQuotas = concat(scorecardQuotas, quotas);
            scorecardTitle.push(title);
        });
    const scorecardQuota = scorecards && uniqBy((x) => x.id, scorecardQuotas);

    program.map((card) => {
        const { title } = card;
        programTitle.push(title);
        programCourseItems += card.stats.courses.total;
    });

    habitSchedules.map((card) => {
        const { data } = card;
        habitSchedulesTitle.push(data.name);
        habitsItem += data.child_count;
    });

    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <PdfHeader style={{ paddingTop: 20 }} header={pageTitle} date={`${dateStart} - ${dateEnd}`} fixed />
                <View wrap style={{ display: 'flex' }}>
                    <View style={styles.mainHeader}>
                        <View style={{ flex: 4 }}>
                            <Text style={styles.title}>Scorecards</Text>
                        </View>
                    </View>
                    <View style={styles.listHeader}>
                        <View style={{ flex: 3.5 }}>
                            <Text style={styles.listHeaderTitle}>Scorecards</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listHeaderTitle}>Courses</Text>
                        </View>
                    </View>
                    <View style={styles.listItem} wrap>
                        <View style={{ flex: 3.5, marginBottom: 5 }}>
                            <Text style={styles.listItemFont}>{isEmpty(scorecardTitle) ? 'No assigned program.' : scorecardTitle.join(', ')}</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listItemFont}>{length(scorecardQuota)}</Text>
                        </View>
                    </View>
                    {ListQuota(scorecardQuota || '', 'Scorecard')}
                </View>
                <View wrap style={{ display: 'flex' }}>
                    <View style={styles.mainHeader}>
                        <View style={{ flex: 4 }}>
                            <Text style={styles.title}>Programs</Text>
                        </View>
                    </View>
                    <View style={styles.listHeader}>
                        <View style={{ flex: 3.5 }}>
                            <Text style={styles.listHeaderTitle}>Programs</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listHeaderTitle}>Courses</Text>
                        </View>
                    </View>
                    <View style={styles.listItem} wrap>
                        <View style={{ flex: 3.5, marginBottom: 5 }}>
                            <Text style={styles.listItemFont}>{isEmpty(programTitle) ? 'No assigned scorecard.' : programTitle.join(', ')}</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listItemFont}>{programCourseItems}</Text>
                        </View>
                    </View>
                    {ListQuota(quotas, 'Program')}
                </View>
                <View wrap style={{ display: 'flex' }} break>
                    <View style={styles.mainHeader}>
                        <View style={{ flex: 4 }}>
                            <Text style={styles.title}>Habit Schedule</Text>
                        </View>
                    </View>
                    <View style={styles.listHeader}>
                        <View style={{ flex: 3.5 }}>
                            <Text style={styles.listHeaderTitle}>Habit Schedule</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listHeaderTitle}>Habits</Text>
                        </View>
                    </View>
                    <View style={styles.listItem} wrap>
                        <View style={{ flex: 0.5 }}>
                            <Text style={styles.listHeaderTitle}>Schedules</Text>
                        </View>
                        <View style={{ flex: 3 }}>
                            <Text style={styles.listItemFont}>{isEmpty(habitSchedulesTitle) ? 'No assigned habit schedule.' : habitSchedulesTitle.join(', ')}</Text>
                        </View>
                        <View style={{ flex: 0.5, textAlign: 'right' }}>
                            <Text style={styles.listItemFont}>{habitsItem}</Text>
                        </View>
                    </View>
                    {ListHabit(dailyHabits, 'Daily', userId)}
                    {ListHabit(weeklyHabits, 'Weekly', userId)}
                    {ListHabit(monthlyHabits, 'Monthly', userId)}
                </View>
                <Text fixed style={styles.pageNumbers} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

export default AssignmentsToDoPdf;
